export default __webpack_public_path__ + "static/media/img-0710-belgium-half-face.3153c93c.png";